// Which top-level view the Helm web console shows (App.tsx Gate), as a pure function so it is testable.
//
// H1: /device needs only /auth/* — never helm_api — so it is shown whenever this browser holds tokens, even when the
// Helm bootstrap failed (not a Helm member yet, server trouble → status 'out' with tokens kept) or still wants the
// Helm passkey (approving asserts one first). Without tokens it is the normal sign-in, which keeps the URL.

export type GateStatus = 'loading' | 'out' | 'in' | 'passkey';
export type GateView = 'spinner' | 'signin' | 'device' | 'passkey' | 'shell';

/** /approve is an alias of /device (CONTRACT_O1_NUMBER_MATCH); the gateway's approve_url stays /device. */
export const DEVICE_PATHS: readonly string[] = ['/device', '/approve'];
export const isDevicePath = (pathname: string): boolean => DEVICE_PATHS.includes(pathname.replace(/\/+$/, '') || '/');

export function gateView(status: GateStatus, pathname: string, authed: boolean): GateView {
  if (isDevicePath(pathname) && authed) return 'device';
  if (status === 'loading') return 'spinner';
  if (status === 'out') return 'signin';
  if (status === 'passkey') return 'passkey';
  return 'shell';
}
